<script lang="ts">
	import { Button } from '$lib/components/ui/button/index.js';
	import { localizeHref } from '@/paraglide/runtime';
	import posthog from 'posthog-js';
	import { onMount } from 'svelte';

	let open = $state(false);
	let bannerEl: HTMLDivElement | null = $state(null);

	onMount(() => {
		const phOptRegex = /^__ph_opt_in_out_/;
		const hasPhOptKey = Object.keys(localStorage).some((key) => phOptRegex.test(key));

		if (!hasPhOptKey) {
			open = true;
		}
	});

	function accept() {
		posthog.opt_in_capturing();
		open = false;
	}

	function reject() {
		posthog.opt_out_capturing();
		open = false;
	}

	function handleClickOutside(event: MouseEvent) {
		if (bannerEl && !bannerEl.contains(event.target as Node)) {
			accept();
		}
	}
</script>

<svelte:document onclick={handleClickOutside} />

{#if open}
	<div
		bind:this={bannerEl}
		class="border-border fixed inset-x-0 bottom-16 z-60 border-t bg-gray-200 md:bottom-0"
	>
		<div
			class="mx-auto flex max-w-7xl flex-col items-center gap-3 px-4 py-3 md:flex-row md:justify-between"
		>
			<p class="text-muted-foreground text-center text-sm md:text-left">
				Usamos cookies para mejorar tu experiencia. Consulta nuestra
				<a href={localizeHref('/politica-de-privacidad')} class="text-foreground underline">
					Política de Privacidad</a
				>.
			</p>

			<div class="flex shrink-0 gap-2">
				<Button variant="outline" size="sm" onclick={reject}>Rechazar</Button>
				<Button size="sm" onclick={accept}>Aceptar</Button>
			</div>
		</div>
	</div>
{/if}
